module.exports = __webpack_public_path__ + "static/phone-carrier-wuitusu-logo-c0f59134facc5705db83471d022f7bfc.png";